import { getCLS, getFCP, getFID, getLCP, getTTFB } from 'web-vitals';
import { satGlobals } from '../sat/helper/sat-globals';
import { isMobile } from '../../lib-sat/misc/browser-detector';
import { globalLogger } from './global-logger';

let satConnectionType = 'unknown';
if (navigator.connection && navigator.connection.effectiveType) {
    if (navigator.connection.effectiveType === '4g') {
        satConnectionType = 'fast';
    } else {
        satConnectionType = 'slow';
    }
}

let de = document.documentElement;
let w = window.innerWidth || self.innerWidth || (de && de.clientWidth) || document.body.clientWidth;
let h = window.innerHeight || self.innerHeight || (de && de.clientHeight) || document.body.clientHeight;
let mobile = isMobile();

function getBootstrapBreakpoint(w) {
    if (w < 567) {
        return 'xs';
    } else if (w < 768) {
        return 'sm';
    } else if (w < 1200) {
        return 'md';
    } else if (w < 1400) {
        return 'lg';
    } else {
        return 'xl';
    }
}

let bootstrapBreakpoint = getBootstrapBreakpoint(w);

function sendToAnalytics(metric) {
    try {
        let url = satGlobals.getApiUrl('api/z');
        let body = JSON.stringify({
            data: {
                message: 'webvital_' + metric.name.toLowerCase(),
                value: metric.value,
                origin: [location.pathname].join(''),
                connection_type: satConnectionType,
                w: w,
                h: h,
                mobile: mobile,
                status: sat.statusCode,
                bs_break_point: bootstrapBreakpoint,
            },
        });

        let headers = {
            type: 'text/plain',
        };

        let blob = new Blob([body], headers);

        if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) {
            return;
        }

        fetch(url, { body, method: 'POST', keepalive: true });
    } catch (e) {
        globalLogger.log('exception while sending vitals analytics', e);
    }
}
try {
    getCLS(sendToAnalytics);
    getFID(sendToAnalytics);
    getLCP(sendToAnalytics);
    getFCP(sendToAnalytics);
    getTTFB(sendToAnalytics);
} catch (e) {
    // do nothing.
}
